import React from "react";

// Circular progress ring (SVG, deterministic).
export function ProgressRing({ value = 0, size = 132, stroke = 12, label, sublabel, testid }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (value / 100) * c;
  const id = "grad-" + Math.round(size);
  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testid}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#5B21B6" />
            <stop offset="100%" stopColor="#A78BFA" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#EDE9FE" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r} stroke={`url(#${id})`} strokeWidth={stroke}
          fill="none" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display text-2xl font-extrabold text-[#4C1D95]">{label ?? `${value}%`}</span>
        {sublabel && <span className="text-[11px] font-medium text-slate-400">{sublabel}</span>}
      </div>
    </div>
  );
}

export function ProgressBar({ value = 0, color = "#8B5CF6", track = "#EDE9FE", className = "" }) {
  return (
    <div className={`h-2 w-full overflow-hidden rounded-full ${className}`} style={{ background: track }}>
      <div className="h-full rounded-full transition-all duration-700" style={{ width: `${value}%`, background: color }} />
    </div>
  );
}
